/**
 * Analytics SDR for Login Domain.
 * This information should match the values in the SDR Excel file referenced here:
 * https://chalk.charter.com/display/ERSPM/FE+Analytics
 */

import { IAnalyticSdrButton, IAnalyticSdrPage } from '../types/analyticsSdr';

export interface IAutoLogoutAnalytics
  extends Pick<IAnalyticSdrPage, 'buttonClicks'> {
  readonly buttonClicks: {
    readonly stillHereBtn: IAnalyticSdrButton;
    readonly signOutBtn: IAnalyticSdrButton;
  };
}

export interface IUserMenuLogoutAnalytics
  extends Pick<IAnalyticSdrPage, 'buttonClicks'> {
  readonly buttonClicks: {
    readonly signOutBtn: IAnalyticSdrButton;
  };
}

export interface ICommonAnalyticsSdr {
  readonly autoLogoutModal: IAutoLogoutAnalytics;
  readonly userMenuLogout: IUserMenuLogoutAnalytics;
}

export const commonAnalytics: ICommonAnalyticsSdr = {
  autoLogoutModal: {
    buttonClicks: {
      stillHereBtn: {
        pageRegion: 'Auto Logout Modal',
        itemClicked: 'Still Here',
      },
      signOutBtn: {
        pageRegion: 'Auto Logout Modal',
        itemClicked: 'Sign Out',
      },
    },
  },
  userMenuLogout: {
    buttonClicks: {
      signOutBtn: {
        pageRegion: 'Settings Menu',
        itemClicked: 'Sign Out',
      },
    },
  },
};
